<template>
  <div>
    <div>
      <strong>{{ $t('component.proj.paymentSumCard.cardTitle') }}</strong>
    </div>
    <Divider />

    <Content class="cust-content">
      <Row class="content-info" id="printDomPaymentTable">
        <Table ref="paymentTable"
               :columns="transColumns" :data="tableData" border width="350"
               show-summary :summary-method="handleSummary"
               :loading="isListLoading">
          <template slot-scope="{ row, index }" slot="paymentName">
            <span>{{ row.paymentName }}</span>
          </template>

          <template slot-scope="{ row, index }" slot="paymentAmt">
            <span>{{ formatThousandthNumber(row.paymentAmt) }}</span>
          </template>
        </Table>
      </Row>
      <br />
      <Row class="content-info">
        <Button type="primary"
                @click="printPage"
                style="min-width: 87px;">
          {{ $t('common.toolBar.printBtn') }}
        </Button>
        <Button type="primary"
                @click="exportData"
                style="min-width: 87px; margin-left: 24px;">
          {{ $t('common.toolBar.exportBtn') }}
        </Button>
      </Row>
    </Content>
  </div>
</template>

<script>
import * as Utils from '@/utils'

export default {
  props: {
    projSettlePaymentDDList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    },
    transList: {
      type: Array,
      require: true,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      isListLoading: false,
      // paymentMap: {},
      tableData: [],
      transColumns: [
        {
          title: this.$t('component.proj.paymentSumCard.paymentName'),
          slot: 'paymentName',
          key: 'paymentName',
          align: 'right',
          // fixed: 'left',
          width: 200
        },
        {
          title: this.$t('component.proj.paymentSumCard.paymentAmt'),
          slot: 'paymentAmt',
          key: 'paymentAmt',
          align: 'right'
          // ,
          // width: 140
        }
      ]
    }
  },
  computed: {
  },
  methods: {
    handleSummary({ columns, data }) {
      const sums = {}
      columns.forEach((column, index) => {
        const key = column.key
        if (!key) {
          sums[key] = {
            key,
            value: ''
          }
          return
        }
        if (key === 'paymentName') {
          sums[key] = {
            key,
            value: this.$t('common.commonVar.total')
          }
          return
        }
        // debugger
        const values = data.map(item => Number(item[key]))
        // let values = []
        // if (key === 'balAmt') {
        //   values = values.concat(data.map(item => Number(item['inAmt'])))
        //   values = values.concat(data.map(item => Number(item['outAmt']) * -1))
        // } else {
        //   values = data.map(item => Number(item[key]))
        // }
        if (!values.every(value => isNaN(value))) {
          const v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[key] = {
            key,
            value: this.formatThousandthNumber(v)
          }
        } else {
          sums[key] = {
            key,
            value: 'N/A'
          }
        }
      })

      return sums
    },
    printPage() {
      // #调试用, 将printFrame显示出来, 便于查看需要打印的内容
      // document.getElementById('printFrame').style.display = 'block'
      // document.getElementById('printFrame').style.height = '50%'
      // document.getElementById('printFrame').style.width = '100%'
      // document.getElementById('printFrame').style.top = '0'
      // document.getElementById('printFrame').style['z-index'] = '10000'
      // document.getElementById('printFrame').style['background-color'] = '#fff'
      let printWindow = document.getElementById('printFrame').contentWindow
      printWindow.document.body.innerHTML = '' // 清楚printFrame的内容
      let node = document.getElementById('printDomPaymentTable').cloneNode(true) // 将需要打印的内容拷贝到printFrame中
      printWindow.document.body.appendChild(node)

      // 处理浮动table，将table的data和summary部分都放到head所在的table中去
      let transTableList = printWindow.document.getElementById('printDomPaymentTable').getElementsByTagName('table')
      transTableList[0].border = '1'
      transTableList[0].appendChild(transTableList[1].getElementsByTagName('tbody')[0])
      transTableList[0].appendChild(transTableList[2].getElementsByTagName('tbody')[0])

      printWindow.print()
    },
    exportData() {
      this.$refs.paymentTable.exportCsv({
        filename: this.$t('component.proj.paymentSumCard.cardTitle')
      })
    },
    formatThousandthNumber: Utils.formatThousandthNumber,
    END_METHODS() {}
  },
  async mounted() {
    // debugger
    // console.log(this.projSettlePaymentDDList)
    let paymentMap = {}
    for (let i = 0; i < this.transList.length; i++) {
      let trans = this.transList[i]
      let paymentAmt = paymentMap[trans.paymentId] ? paymentMap[trans.paymentId] : 0
      if (trans.paymentId && (trans.payAmt)) {
        paymentMap[trans.paymentId] = paymentAmt + trans.payAmt
      }
    }

    this.tableData = []
    for (let i = 0; i < this.projSettlePaymentDDList.length; i++) {
      let payment = {...this.projSettlePaymentDDList[i]}
      payment.paymentAmt = paymentMap[payment.paymentId] || 0
      this.tableData.push(payment)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/proj/PaymentSumCard.vue